import { ScoreBreakdownCategories, type DynamicActionAggregation } from '../../../apiHooks/useScoreBreakdownByUserQuery';

const CATEGORY_ORDER: Record<string, number> = {
    [ScoreBreakdownCategories.COMPLETION]: 0,
    [ScoreBreakdownCategories.KNOWLEDGE]: 1,
    [ScoreBreakdownCategories.DATA_PROTECTION]: 2,
    [ScoreBreakdownCategories.MICROSOFT_IDENTITY]: 3,
    [ScoreBreakdownCategories.ENGAGEMENT]: 4,
    [ScoreBreakdownCategories.EMAIL_SECURITY]: 5,
    [ScoreBreakdownCategories.PHISHING_CLICKS]: 6,
    [ScoreBreakdownCategories.PHISHING_REPORTS]: 7,
};

const getCategoryOrder = (scoreBreakdown: string): number => {
    return CATEGORY_ORDER[scoreBreakdown] ?? 999;
};

export const sortDynamicActions = (items: DynamicActionAggregation[]): DynamicActionAggregation[] => {
    return [...items].sort((a, b) => {
        const catDiff = getCategoryOrder(a.scoreBreakdown) - getCategoryOrder(b.scoreBreakdown);
        if (catDiff !== 0) return catDiff;
        const nameDiff = a.actionName.localeCompare(b.actionName);
        if (nameDiff !== 0) return nameDiff;
        return a.actionScoreType - b.actionScoreType;
    });
};
